/**
 * 管理后台侧边栏组件
 *
 * 基于 page-dedsign.pen 原型设计的深色导航栏
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    DashboardOutlined,
    DatabaseOutlined,
    QuestionCircleOutlined,
    SettingOutlined,
    TeamOutlined,
    RobotOutlined,
    LogoutOutlined,
    MessageOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../../stores/authStore';
import ChangePasswordModal from './ChangePasswordModal';

const menuItems = [
    { key: '/admin/dashboard', icon: <DashboardOutlined />, label: '总览' },
    { key: '/admin/knowledge', icon: <DatabaseOutlined />, label: '知识库配置' },
    { key: '/admin/faq', icon: <QuestionCircleOutlined />, label: 'FAQ 管理' },
    { key: '/admin/conversations', icon: <MessageOutlined />, label: '会话管理' },
    { key: '/admin/model', icon: <SettingOutlined />, label: '模型配置' },
    { key: '/admin/users', icon: <TeamOutlined />, label: '用户权限' },
];

const AdminSidebar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout, user } = useAuthStore();
    const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    return (
        <div
            style={{
                width: 240,
                height: '100vh',
                background: '#18181b',
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0,
            }}
        >
            {/* Logo 区域 */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '20px 20px',
                    borderBottom: '1px solid #27272a',
                }}
            >
                <RobotOutlined style={{ fontSize: 24, color: '#3b82f6' }} />
                <span style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}>智能客服</span>
            </div>

            {/* 导航菜单 */}
            <div style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.key;
                    return (
                        <div
                            key={item.key}
                            onClick={() => navigate(item.key)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                padding: '10px 16px',
                                marginBottom: 2,
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontSize: 14,
                                fontWeight: isActive ? 600 : 400,
                                color: isActive ? '#fff' : '#a1a1aa',
                                background: isActive ? '#2563eb' : 'transparent',
                                transition: 'all 0.15s ease',
                            }}
                            onMouseEnter={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.background = '#27272a';
                                    e.currentTarget.style.color = '#fff';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.color = '#a1a1aa';
                                }
                            }}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </div>
                    );
                })}
            </div>

            {/* 底部用户信息 + 登出 */}
            <div style={{ padding: '12px 8px', borderTop: '1px solid #27272a' }}>
                <div
                    onClick={() => setChangePasswordOpen(true)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '10px 16px',
                        borderRadius: 8,
                        marginBottom: 4,
                        cursor: 'pointer',
                    }}
                >
                    <div
                        style={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            background: '#3b82f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 600,
                        }}
                    >
                        {user?.username?.[0]?.toUpperCase() || 'A'}
                    </div>
                    <div>
                        <div style={{ color: '#fff', fontSize: 13, fontWeight: 500 }}>
                            {user?.username || 'admin'}
                        </div>
                        <div style={{ color: '#71717a', fontSize: 11 }}>
                            {user?.email || 'admin@example.com'}
                        </div>
                    </div>
                </div>
                <div
                    onClick={handleLogout}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '10px 16px',
                        borderRadius: 8,
                        cursor: 'pointer',
                        color: '#a1a1aa',
                        fontSize: 14,
                        transition: 'all 0.15s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#ef4444';
                        e.currentTarget.style.background = '#27272a';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#a1a1aa';
                        e.currentTarget.style.background = 'transparent';
                    }}
                >
                    <LogoutOutlined />
                    <span>退出登录</span>
                </div>
                <ChangePasswordModal
                    open={changePasswordOpen}
                    onCancel={() => setChangePasswordOpen(false)}
                />
            </div>
        </div>
    );
};

export default AdminSidebar;
